import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AcceptChanges = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.5763 9.09317C20.801 9.25368 20.8531 9.56595 20.6926 9.79066L14.264 18.7907C14.182 18.9055 14.0552 18.9804 13.915 18.9967C13.7747 19.013 13.6342 18.9693 13.5279 18.8763L9.67077 15.5016C9.46294 15.3198 9.44187 15.0039 9.62371 14.7961C9.80554 14.5883 10.1214 14.5672 10.3292 14.749L13.771 17.7603L19.8789 9.20942C20.0394 8.98471 20.3516 8.93267 20.5763 9.09317Z"
        />
        <path stroke={color} opacity="0.3" d="M4.5 7L16.5 7" strokeLinecap="round" />
        <path stroke={color} opacity="0.3" d="M4.5 11H13.5" strokeLinecap="round" />
      </svg>
    )
  },
)

export default AcceptChanges
